import React from 'react';
import '../styles/Global.css'; // Shared CSS file for consistent styling

import Header from './Header';
import Footer from './Footer';

const AboutUs: React.FC = () => (
        <div className="page-container">
            <Header />  
            <main className="page-content">
                <section className="about-section">
                    <h1>About Us</h1>
                    <p>
                        At Consphic, we are dedicated to delivering innovative solutions that drive success. 
                        Our team of experts is committed to excellence and customer satisfaction.
                    </p>
                </section>
            </main>
            <Footer/>
        </div>
    );
export default AboutUs;